/**
 * The base class for global controllers.
 */
export default class GlobalBase {

    constructor() {
        // Run docReady on after document is loaded.
        document.addEventListener("DOMContentLoaded", () => {
            this.docReady();
        });
    }
}
